export const STATUS = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  SUBMITTED: 'SUBMITTED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED',
  REVISED: 'REVISED',
};

export const STATUS_VALUES = Object.values(STATUS);

export const STATUS_COLORS = {
  [STATUS.DRAFT]: '#e5e9f2', // Light gray
  [STATUS.ACTIVE]: '#33cb99', // Green
  [STATUS.SUBMITTED]: '#33cb99', // Green
  [STATUS.ACCEPTED]: '#33cb99', // Green
  [STATUS.REJECTED]: '#f15757', // Red
  [STATUS.EXPIRED]: '#f15757', // Red
  [STATUS.CANCELED]: '#f15757', // Red
  [STATUS.REVISED]: '#e5e9f2', // Light gray
};
